/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PriceItPlusBrand from './price-it-plus-brand';
import PriceItPlusDescription from './price-it-plus-description';
import PriceItPlusPoints from './price-it-plus-points';

class PriceItPlusPerformance extends Component {
  render() {
    const { data } = this.props;

    return (
      <div className="incentive-performance">
        <PriceItPlusDescription data={data} />
        <PriceItPlusBrand data={data} />
        {data.enrollment_status === 'Enrolled' && <PriceItPlusPoints data={data} />}
      </div>
    );
  }
}

export default PriceItPlusPerformance;



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/subcomponents/price-it-plus-performance.jsx